import { Trans } from '@lingui/macro'
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import sfOauthConfig from '../../services/sfAuth/sfAuthConfig'

const Brand = (props) => {
  const sx = props?.sx || {}
  const settings = useSelector(state => state.layout.settings)
  const activeTheme = { ...settings.themes[settings.activeTheme] }
  const history = useHistory()

  const user = useSelector(state => state.user)

  const language = user.language || 'en'

  return (
    <Box
      className={`flex flex-middle flex-space-between  brand-area brand-area-${language}`}
      data-tut='reactour__logo'
      style={{ cursor: 'pointer' }}
      onClick={e => {
        history.push('/')
      }}
      sx={{ ...sx, flexWrap: 'nowrap' }}
    >
      <div className='flex flex-middle brand'>
        <img src={activeTheme.header.image} alt='company-logo' className='company-logo' />
        <Typography className='brand__text' sx={{ color: '#17374F', fontFamily: 'Open Sans' }}>
          {sfOauthConfig.isIcce ? <Trans>ICCE</Trans> : <Trans>The Centre</Trans>}
        </Typography>
      </div>
    </Box>
  )
}

export default Brand
